<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.whitelist">
  <app-popup-header title="{{localService.languageContent.whitelist.add_title}}" [top]="10" [isPopup]="isPopup"></app-popup-header>
  <div class="modal-body modal-body-no-flexible-height" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div *ngIf="id == ''">
      <app-country-contact [ctryCode]="ctryCode" [phoneNumber]="phoneNumber" (onContactUpdated)="onContactUpdated($event)" (onEnterPressed)="localService.onFocusNextInput(elementIds.name,1)"></app-country-contact>
      <div class="row">
        <div class="col-12">
          <input autocomplete="off" type="text" [(ngModel)]="data.v2" id="{{elementIds.name}}" placeholder="{{localService.languageContent.whitelist.nme}}" title="{{localService.languageContent.whitelist.nme}}" (keydown.enter)="localService.onFocusNextInput(elementIds.comment,1)" (input)="onMessageClear()"/>
        </div>
      </div>
    </div>
    <div *ngIf="id != '' && item" style="margin-bottom:10px;">
      <div class="row">
        <div class="col-6">
          {{localService.languageContent.whitelist.ph_num}}
        </div>
        <div class="col-6 en">
          {{item.v1}}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          {{localService.languageContent.whitelist.nme}}
        </div>
        <div class="col-6">
          {{item.v2}}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          {{localService.languageContent.whitelist.cmt}}
        </div>
        <div class="col-6">
          {{item.v3}}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          {{localService.languageContent.whitelist.status}}
        </div>
        <div class="col-6">
          <ngx-select [(ngModel)]="item.v4" *ngIf="statuses" [optionValueField]="'key'" [optionTextField]="'value'" [items]="statuses" [noAutoComplete]="true" (open)="onMessageClear()">
          </ngx-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <textarea rows="3" [(ngModel)]="data.v3" id="{{elementIds.comment}}" placeholder="{{localService.languageContent.whitelist.cmt}}" title="{{localService.languageContent.whitelist.cmt}}" (keydown.enter)="localService.onFocusNextInput(elementIds.save,6)" (input)="onMessageClear()"></textarea>
      </div>
    </div>
    <div *ngIf="message != ''" style="text-align:center;">
      <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'yellowgreen' }">{{message}}</span>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()" id="{{elementIds.save}}">{{id != '' ? localService.languageContent.common.update : localService.languageContent.common.add}}</button>
  </div>
</div>
